export default {
  name: 'Sky Social Share',
  selector: '.j-social-share:not([data-initialized])',
};
